/**
 * Single source of truth for project-mode display labels.
 *
 * INTERNAL IDS ARE FROZEN FOREVER — they live in project metadata
 * (referenceImagesJson.projectMode) and in analytics (`project_mode` on
 * PostHog/GA events), so renames must never touch them. Renaming a mode =
 * change the label here; the UI pickers and the `project_mode_label`
 * analytics property both derive from this map, so they cannot drift.
 *
 * History (support/analytics triage): until 2026-07-08 the id "studio" was
 * shown as "Studio" and "fast_v2" as "Fast". From 2026-07-08, "fast_v2" is
 * shown as "Studio" and "studio" as "Director". When discussing modes in
 * tickets or docs, always include the internal id: Studio (`fast_v2`),
 * Director (`studio`), Lite (`fast`).
 */
export const PROJECT_MODE_UI_LABELS = {
  fast_v2: "Studio",
  studio: "Director",
  fast: "Lite",
  dance: "Dance",
} as const;

export type ProjectModeId = keyof typeof PROJECT_MODE_UI_LABELS;

/** Lowercase label for analytics (`project_mode_label`). */
export function projectModeAnalyticsLabel(mode: unknown): string | undefined {
  if (typeof mode !== "string") return undefined;
  const label = PROJECT_MODE_UI_LABELS[mode as ProjectModeId] ?? undefined;
  return label ? label.toLowerCase() : undefined;
}
